/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeclinePendingDocShareMutationVariables = Types.Exact<{
  input: Types.DeclinePendingDocShareInput;
}>;


export type DeclinePendingDocShareMutation = { declinePendingDocShare: { __typename: 'DeclinePendingDocShareResult', ok: boolean } };


export const DeclinePendingDocShareDocument = gql`
    mutation DeclinePendingDocShare($input: DeclinePendingDocShareInput!) {
  declinePendingDocShare(input: $input) {
    ok
  }
}
    `;
export type DeclinePendingDocShareMutationFn = Apollo.MutationFunction<DeclinePendingDocShareMutation, DeclinePendingDocShareMutationVariables>;

/**
 * __useDeclinePendingDocShareMutation__
 *
 * To run a mutation, you first call `useDeclinePendingDocShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclinePendingDocShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declinePendingDocShareMutation, { data, loading, error }] = useDeclinePendingDocShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclinePendingDocShareMutation(baseOptions?: Apollo.MutationHookOptions<DeclinePendingDocShareMutation, DeclinePendingDocShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclinePendingDocShareMutation, DeclinePendingDocShareMutationVariables>(DeclinePendingDocShareDocument, options);
      }
export type DeclinePendingDocShareMutationHookResult = ReturnType<typeof useDeclinePendingDocShareMutation>;
export type DeclinePendingDocShareMutationResult = Apollo.MutationResult<DeclinePendingDocShareMutation>;
export type DeclinePendingDocShareMutationOptions = Apollo.BaseMutationOptions<DeclinePendingDocShareMutation, DeclinePendingDocShareMutationVariables>;